import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_t2f2m59z3d: FaireBrandEntity = {
  token: "b_t2f2m59z3d",
  type: "brand",
  name: "El Joyero",
  avatarUrl:
    "https://cdn.faire.com/fastly/88a60284c12a612c5260eaaa53620ba5004022dcfe211aeb3853f056618c53f9.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/18d74ae8be2ca0b29632d886ff8196a570839752685caf5313704a78d32b7b7b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/88a60284c12a612c5260eaaa53620ba5004022dcfe211aeb3853f056618c53f9.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/18d74ae8be2ca0b29632d886ff8196a570839752685caf5313704a78d32b7b7b.jpeg",
  location: "GBR",
  minimumOrderDollars: 67,
  rating: 5,
  reviewCount: 9,
  isTopShop: true,
  isInsider: false,
  description:
    "We are a family run business that has been collecting, manufacturing and working with beads, gemstones and silver, Gold , Brass jewelry for over 25 years. We make all types stylish earring , necklace, rings and much more Jewelry I traveled to the North-East Indian tribal areas to get inspirations from the old culture and came up with a new jewelry collection that is very simple yet very beautiful. My designs are timeless.\nOver time as we opened our world to friends and family, it attracted attention and allowed to grow organically. And now",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:02:46.207Z",
    importedBy: "entity-db-cli",
  },
};
